import axios from 'axios'
import helpers from "@/services/helpers";
export default {
  namespaced: true,

  state: {
    terms: []
  },

  getters: {
    terms: state => state.terms,
  },

  mutations: {
    setTerms(state, payload) {
      state.terms = payload
    },
  },

  actions: {
    async getTerms({ commit }, {language, company}) {
      console.log(language)
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        if(!company){
          const res = await axios.get(`/api/terms_conditions?lang=${language}`)
          commit('setTerms', res.data.data[0])
          return res.data
        }else{
          const res = await axios.get(`/api/company/${company}/terms-and-conditions?lang=${language}`)
          console.log(res)
          commit('setTerms', res.data.data)
          return res.data
        }
      } catch (error) {
        
        throw error
      } finally {
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
    async createOrUpdate({ commit }, payload) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        if(!payload.company){
          if (!payload.id) {
            const resp = await axios.post('/api/terms_conditions', payload)
            return resp.data
          } else {
            const res = await axios.put(`/api/terms_conditions/${payload.id}`, {
              _method: 'PUT',
              ...payload
            })
            return res.data
          }
        }else{
          if (!payload.id) {
            const resp = await axios.post(`/api/company/${payload.company}/terms-and-conditions`, payload)
            return resp.data
          } else {
            const res = await axios.put(`/api/terms_conditions/${payload.id}`, {
              _method: 'PUT',
              ...payload
            })
            return res.data
          }
        }
      } catch (error) {
        
        throw error
      } finally {
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
    /*async delete ({ commit }, id) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        const res = await axios.delete(`api/products/${id}`)
        return res.data
      } catch (error) {
        
        throw error
      } finally {
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },*/

  },
}
